/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineObject11 model module.
 * @module model/InlineObject11
 * @version 1.0.0
 */
class InlineObject11 {
    /**
     * Constructs a new <code>InlineObject11</code>.
     * @alias module:model/InlineObject11
     * @param documentTypeId {Number} 
     * @param file {File} 
     */
    constructor(documentTypeId, file) { 
        
        InlineObject11.initialize(this, documentTypeId, file);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, documentTypeId, file) { 
        obj['document_type_id'] = documentTypeId;
        obj['file'] = file;
    }

    /**
     * Constructs a <code>InlineObject11</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineObject11} obj Optional instance to populate.
     * @return {module:model/InlineObject11} The populated <code>InlineObject11</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineObject11();

            if (data.hasOwnProperty('comment')) {
                obj['comment'] = ApiClient.convertToType(data['comment'], 'String');
            }
            if (data.hasOwnProperty('document_type_id')) {
                obj['document_type_id'] = ApiClient.convertToType(data['document_type_id'], 'Number');
            }
            if (data.hasOwnProperty('file')) {
                obj['file'] = ApiClient.convertToType(data['file'], File);
            }
        }
        return obj;
    }


}

/**
 * @member {String} comment
 */
InlineObject11.prototype['comment'] = undefined;

/**
 * @member {Number} document_type_id
 */
InlineObject11.prototype['document_type_id'] = undefined;

/**
 * @member {File} file
 */
InlineObject11.prototype['file'] = undefined;






export default InlineObject11;

